import EscCard from "../components/EscCards/EscCards"


function RCPage (){
    return(
        <div className="pt-5">
            <h1 className="text-esc">ESCALADA EN ROCA</h1>
           
            <EscCard/>
            
        </div>
    )
}

export default RCPage